import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { AdjustmentMethodType, AdjustmentType } from "./types";

export const AdjustmentMethodTypeOptions = [
  {
    label: i18n.t("adjustManually"),
    value: AdjustmentMethodType.Manual,
    description: i18n.t(
      "selectTheListOfEmployeesAndInputAnAdjustmentAmountThatWillApplyToAllSelectedEmployees"
    ),
  },
  {
    label: i18n.t("importFile"),
    value: AdjustmentMethodType.Import,
    description: i18n.t(
      "fillTheAdjustmentInformationAndListOfApplicableEmployeesIntoTheExcelFileAndThenImportItIntoTheSystem"
    ),
  },
];

export const AdjustmentTypeOptions = [
  {
    label: i18n.t("incomeBeforeTax"),
    value: AdjustmentType.BeforeTax,
  },
  {
    label: i18n.t("incomeAfterTax"),
    value: AdjustmentType.AfterTax,
  },
];

export const AdjustmentTypeMap = getMapObjectFromArray(AdjustmentTypeOptions);
